<template>
  <div class="ml-4 mt-1 text-sm text-gray-500">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
